import { IApiError } from '@/models/apiError.model';
import { IBaseLLMTemplate } from '@/models/llmTemplate.model';

export const SLICE_NAME = 'llmTemplates';

export interface LLMTemplatesState {
  templates: IBaseLLMTemplate[] | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: LLMTemplatesState = {
  templates: null,
  isLoading: false,
  error: null,
};
